import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const PrivacyPolicy = () => {
  return (
    <div 
      className="min-h-screen bg-primary flex flex-col"
      style={{
        backgroundImage: "url('/lovable-uploads/c8651ff7-9b42-42de-8d0c-3fe96c28c70f.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <Navbar />
      <div className="container mx-auto px-4 py-24 flex-grow animate-slide-in-right">
        <div className="max-w-4xl mx-auto bg-primary/40 backdrop-blur-md rounded-lg p-8 text-white/90">
          <h1 className="text-4xl font-bold mb-6 text-white">Política de Privacidade</h1>
          
          <div className="space-y-4">
            <section>
              <h2 className="text-2xl font-semibold mb-2">1. Introdução</h2>
              <p>A AutoMate Labs está comprometida em proteger sua privacidade. Esta política descreve como coletamos, usamos e protegemos suas informações pessoais.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">2. Coleta de Dados</h2>
              <p>Coletamos informações que você nos fornece diretamente, incluindo:</p>
              <ul className="list-disc list-inside mt-1 ml-4">
                <li>Nome e informações de contato</li>
                <li>Informações da empresa</li>
                <li>Dados de uso do serviço</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">3. Uso das Informações</h2>
              <p>Utilizamos suas informações para:</p>
              <ul className="list-disc list-inside mt-1 ml-4">
                <li>Fornecer e melhorar nossos serviços</li>
                <li>Comunicar sobre atualizações e ofertas</li>
                <li>Personalizar sua experiência</li>
                <li>Cumprir obrigações legais</li>
              </ul>
              <p className="mt-2">Importante: Não compartilhamos seus dados pessoais com terceiros sob nenhuma circunstância.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">4. Proteção de Dados</h2>
              <p>Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">5. Seus Direitos</h2>
              <p>Você tem direito a:</p>
              <ul className="list-disc list-inside mt-1 ml-4">
                <li>Acessar seus dados pessoais</li>
                <li>Corrigir dados imprecisos</li>
                <li>Solicitar a exclusão de seus dados</li>
                <li>Retirar seu consentimento</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">6. Contato</h2>
              <p>Para questões sobre esta política ou seus dados pessoais, entre em contato conosco através do WhatsApp ou email.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">7. Atualizações</h2>
              <p>Esta política pode ser atualizada periodicamente. A versão mais recente estará sempre disponível em nosso site.</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;